const documentReviewV2En = {
  // Page header
  "Document Review": "Document Review",
  "Viewing Document": "Viewing Document",
  "Editing Document": "Editing Document",
  "Confidence Score": "Confidence Score",

  // Three-dot menu
  "View Original Document": "View Original Document",
  "Download Document": "Download Document",
  "Download document": "Download document",
  "Download JSON": "Download JSON",
  "View Accounting Period": "View Accounting Period",
  "Show Hidden Fields": "Show Hidden Fields",
  "Delete Document": "Delete Document",
  "Send For Approval": "Send For Approval",

  // Toolbar
  "Show document viewer": "Show document viewer",
  "Hide document viewer": "Hide document viewer",
  History: "History",
  Notes: "Notes",
  rotate: "Rotate",
  zoom_out: "Zoom out",
  zoom_in: "Zoom in",
  capture_field: "Capture field",
  capture_field_banner_text:
    "Drag or draw a bounding box around value to copy it for highlighted field",
  capture_field_close: "Close",
  capture_select_field_first:
    "Select a field or cell first, then drag over the value",
  capture_scanning_document: "Scanning document...",

  // Document viewer
  "Unable to load document": "Unable to load document",
  "The document could not be retrieved. Please try again.": "The document could not be retrieved. Please try again.",

  // Header actions
  "Re-review Document to Update Details": "Re-review Document to Update Details",
  "Update details": "Update details",
  "Re-Process Document": "Re-Process Document",

  // Right panel
  "Edit Mode is Currently Active": "Edit Mode is Currently Active",
  "Save Changes": "Save Changes",
  "Extraction Rules": "Extraction Rules",
  "Auto Mapping": "Auto Mapping",
  is_being_reviewed: "Being reviewed",

  // Tabs
  "General Info": "General Info",
  "Line Items": "Line Items",
  Coding: "Coding",
  "No coding lines yet": "No coding lines yet",
  Amount: "Amount",

  // Validation bar
  Mandatory: "Mandatory",
  "Fields Required": "Fields Required",
  Discrepancies: "Discrepancies detected",
  "Mandatory Field": "Mandatory field not extracted",
  Detected: "Detected",
  Fix: "Fix",
  View: "View",

  // PostProcessing section labels
  "Supplier Details": "Supplier Details",
  "Customer Details": "Customer Details",
  "Company Details": "Company Details",

  entity_supplier: "Supplier",
  entity_payment_term: "Payment Term",
  entity_payment_method: "Payment Method",
  entity_customer: "Customer",
  entity_company: "Company",
  entity_status_unresolved: "Unresolved",
  entity_status_mismatched: "Mismatched",
  entity_status_matched_warning: "Matched with warning",
  new_supplier_for_company: "New supplier for this company",
  supplier_new_supplier_for_company: "New supplier for this company",
  new_customer_for_company: "New customer for this company",
  customer_new_customer_for_company: "New customer for this company",
  vatid_doesnt_match: "VAT ID doesn't match",
  supplier_vatid_doesnt_match: "Supplier VAT ID doesn't match",
  customer_vatid_doesnt_match: "Customer VAT ID doesn't match",
  company_reference_not_found: "Company reference not found",
  reference_not_found: "Reference not found",
  supplier_reference_not_found: "Supplier reference not found",
  customer_reference_not_found: "Customer reference not found",
  not_registered_for_company: "Not registered for this company",
  supplier_not_registered_for_company: "Supplier not registered for this company",
  customer_not_registered_for_company: "Customer not registered for this company",
  update_account_class_to_edit: "Update the account class first to edit",
  supplier_permission_required: "Supplier permission required",
  customer_permission_required: "Customer permission required",
  company_permission_required: "Company permission required",
  Document: "Document",

  // Field actions
  "Not Found": "Not Found",
  "View Mapping Logs": "View Mapping Logs",
  remove_field: "Remove field",
  "Remove Field": "Remove Field",
  "Are you sure you want to remove this field? This action cannot be undone.":
    "Are you sure you want to remove this field? This action cannot be undone.",

  // Line items table
  Expand: "Expand",
  "No data available": "No data available",
  "Enter edit mode to add rows": "Enter edit mode to add rows",

  // Editable table
  Actions: "Actions",
  "Duplicate row": "Duplicate row",
  "Delete row": "Delete row",
  "Delete Row": "Delete Row",
  "You do not have permission to update coding": "You do not have permission to update coding",
  "Total coding amount ({{sum}}) cannot exceed the invoice total without tax ({{amount}})":
    "Total coding amount ({{sum}}) cannot exceed the invoice total without tax ({{amount}})",
  "Total coding amount ({{sum}}) is less than the invoice total without tax ({{amount}})":
    "Total coding amount ({{sum}}) is less than the invoice total without tax ({{amount}})",
  "Are you sure you want to remove this row? This action cannot be undone.":
    "Are you sure you want to remove this row? This action cannot be undone.",
  "Delete Selected": "Delete Selected",
  "Delete Rows": "Delete Rows",
  "Are you sure you want to remove the selected rows? This action cannot be undone.":
    "Are you sure you want to remove the selected rows? This action cannot be undone.",
  "Add New Items": "Add New Items",
  "Row Number(Optional)": "Row Number (Optional)",
  "No of Items (Optional)": "No of Items (Optional)",
  "No rows yet — click": "No rows yet — click",
  "below.": "below.",
  Add: "Add",

  // History panel
  "Document History": "Document History",
  "No history available": "No history available",
  "State Changed": "State Changed",
  "Failure Reason": "Failure Reason",
  "Failed Integration": "Failed Integration",
  Rejected: "Rejected",
  Reviewed: "Reviewed",
  Uploaded: "Uploaded",

  // Delete document
  "Document deleted successfully": "Document deleted successfully",
  "Are you sure you want to delete this document? This action cannot be undone.":
    "Are you sure you want to delete this document? This action cannot be undone.",

  // Document status chip (from enum.json documentStatus)
  Awaiting: "Awaiting",
  Processed: "Processed",
  Failed: "Failed",
  Error: "Error",
  "Needs Review": "Needs Review",
  Duplicate: "Duplicate",

  // Notes panel
  "Document Notes": "Document Notes",
  "Post comment": "Post comment",
  "Add a comment": "Add a comment",
  delete_note: "Delete note",
  delete_note_title: "Delete note",
  delete_note_confirmation: "Are you sure you want to delete this note? This action cannot be undone.",

  // Mandatory fields modal
  "Mandatory Fields Missing": "Mandatory Fields Missing",
  "General Fields missing": "General Fields missing",
  "Line Item Fields missing": "Line Item Fields missing",
  "No missing general fields": "No missing general fields",

  // Review required modal
  "Delete Table": "Delete Table",
  "Are you sure you want to delete this table? This action cannot be undone.": "Are you sure you want to delete this table? This action cannot be undone.",
  "Review Required Fields": "Review Required Fields",
  "fields require review": "fields require review",
  "No review required fields": "No review required fields",
  "Review Required": "Review Required",
  Review: "Review",
  Required: "Required",
  "No missing fields": "No missing fields",
  "Enter value": "Enter value",
  Row: "Row",
  "rows found": "rows found",
  Update: "Update",

  // Accounting period modal
  "This period is used for accounting purposes": "This period is used for accounting purposes",
  "Open Date": "Open Date",
  "Close Date": "Close Date",
  "Close period": "Close period",
  "Close accounting period": "Close accounting period",
  "Are you sure you want to close the accounting period? Once the period is closed, all documents for that period will be non-editable.":
    "Are you sure you want to close the accounting period? Once the period is closed, all documents for that period will be non-editable.",

  // Mapping logs modal
  "Mapping Logs": "Mapping Logs",
  "View different mappings applied to field to assign value":
    "View different mappings applied to field to assign value",
  "Updated from": "Updated from",
  "To New Value": "To New Value",
  "Mandatory Fields Label Tooltip": "Check Viewing Document mode to see updated values of Line Item Fields",
  "Mandatory Fields Label Description": "Some Missing Line Items fields may already be resolved via mapping or post-processors",
  "Edit Mode Label": "Values updated via Mapping and Post-processors are visible in Viewing Document Mode",
  "Edit Mode Label Tooltip": "Check Viewing Document mode to see final values",
  coding_lines_total_mismatch: "Coding lines total mismatch",
  document_total_without_tax_unavailable: "Document total without tax is unavailable",
  coding_lines_total_unparseable: "Coding lines total could not be parsed",
  classify_document_first:
    "Please classify this document first by selecting its Account Class and Document Class.",
  master_data: "Master Data",
  master_item: "Item",
  master_tax: "Tax",
  master_purchase_order_line: "Order Line",
  master_delivery_note_line: "Delivery Note Line",
  master_grn_line: "GRN Line",
  master_document_number: "Document Number",
  master_line: "Line",
  item_permission_required: "Item permission required",
  tax_permission_required: "Tax permission required",
  standard_review_external_document:
    "External documents cannot be reviewed here.",
  standard_review_po_invoice: "PO invoice",
  standard_review_non_po_invoice: "Non PO invoice",
  standard_review_po_not_found: "PO not found",
  standard_review_includes_services: "Includes services",
  standard_review_includes_items: "Includes items",
  standard_review_review_item_type: "Review item's type",
  no_preview_available: "No preview available",
  item_lines_reference_missing: "Item lines reference is missing",
  standard_viewing_AccountPayable: "Viewing Payable {{documentClass}} Document",
  standard_editing_AccountPayable: "Editing Payable {{documentClass}} Document",
  standard_viewing_AccountReceivable: "Viewing Receivable {{documentClass}} Document",
  standard_editing_AccountReceivable: "Editing Receivable {{documentClass}} Document",
  standard_viewing_unclassified: "Viewing Unclassified Document",
  standard_editing_unclassified: "Editing Unclassified Document",

  // Standard review (/standard GET/PUT) error keys. Dynamic: {{0}} = Values[0]
  document_review_docclass_required: "Document class is required.",
  document_review_docclass_shouldbe_oneof:
    "Document class is not a valid document type.",
  standard_review_docclass_unknown:
    "Document class cannot be Unknown. Please select a document class.",
  standard_review_accountclass_required: "Account class is required.",
  standard_review_accountclass_shouldbe_oneof:
    "Account class must be Account Payable or Account Receivable.",
  system_being_updated:
    "The system is being updated. Please try again in a few minutes.",
  organization_standardization_disable:
    "Standardization is disabled for your organization.",
  organization_asyncreview_disable:
    "Asynchronous review is disabled for your organization.",
  standard_review_form_not_supported:
    "Documents created from a form cannot be reviewed here.",
  standard_review_coding_not_applicable:
    "Coding lines can only be added to non-PO service invoices (Account Payable).",
  standard_review_company_required: "Company is required.",
  standard_review_supplier_required:
    "Supplier is required for Account Payable documents.",
  standard_review_customer_required:
    "Customer is required for Account Receivable documents.",
  standard_review_invalid_number: `"{{0}}" must be empty or a valid number. Whole-number fields accept integers only; decimals use "." without thousand separators (e.g. 1234.56).`,
  standard_review_company_not_found: "Company '{{0}}' was not found.",
  standard_review_supplier_not_found: "Supplier '{{0}}' was not found.",
  standard_review_customer_not_found: "Customer '{{0}}' was not found.",
  standard_review_paymentterm_not_found: "Payment term '{{0}}' was not found.",
  standard_review_paymentmethod_not_found:
    "Payment method '{{0}}' was not found.",
  standard_review_supplier_not_allowed:
    "Supplier '{{0}}' is not allowed on an Account Receivable document.",
  standard_review_customer_not_allowed:
    "Customer '{{0}}' is not allowed on an Account Payable document.",
  standard_review_item_not_found: "Item '{{0}}' was not found.",
  standard_review_tax_not_found: "Tax '{{0}}' was not found.",
  standard_review_dimension_not_found: "Dimension '{{0}}' was not found.",
  standard_review_dimension_value_not_found:
    "Dimension value '{{0}}' was not found.",
  standard_review_dimension_value_mismatch:
    "Dimension value '{{0}}' does not belong to the selected dimension.",
  standard_review_line_not_found: "Line '{{0}}' was not found on this document.",
  standard_review_line_type_mismatch:
    "Line '{{0}}' belongs to another line type.",
  standard_review_duplicate_line: "Line '{{0}}' was sent more than once.",
  document_review_not_found: "Document '{{0}}' was not found.",
  review_document_include_schedulepaymentbill:
    "This document cannot be reviewed because it is included in scheduled payment bill '{{0}}'.",
};

export default documentReviewV2En;
